export { default } from './DeviceTable';
